import { Fragment } from 'react';
import { View } from 'react-native';
import { Divider, Text } from '@ui-kitten/components';

import constants from '../../Config/constants';
import { checkout } from '../../RTK/defaultValues';
import ThemeStyle from '../../Theme/styles';
import { SECTION_TITLE_LIGHT } from '../../Theme/typographyProps';

import useCheckoutHandler from './controller/useCheckoutHandler';
import styles from './styles';
import ThirdPartyAndVehicleInputs from './ThirdPartyAndVehicleInputs';

const fields = [
  { key: 'make', label: 'Vehicle Make' },
  { key: 'color', label: 'Vehicle Color' },
  { key: 'plateNumber', label: 'Vehicle Plate Number' },
];

// for curbside form
function VehicleInformation({ disabled }) {
  const { formVehicleInformation, isCurbside, onUpdateCheckoutDetails } =
    useCheckoutHandler();

  const _onChange = (key) => (fieldValue) => {
    onUpdateCheckoutDetails(checkout.keys.VEHICLE_INFORMATION, {
      ...formVehicleInformation,
      [key]: fieldValue,
    });
  };

  if (!isCurbside) return null;

  return (
    <Fragment>
      <View style={ThemeStyle.pageVerticalSpacingMedium}>
        <View style={styles.webBox}>
          <Text style={ThemeStyle.spacingBottomMedium} {...SECTION_TITLE_LIGHT}>
            Vehicle Information
          </Text>

          <ThirdPartyAndVehicleInputs
            disabled={disabled}
            fields={fields}
            value={formVehicleInformation}
            onChange={_onChange}
          />
        </View>
      </View>
      {!constants.isWeb && <Divider style={ThemeStyle.divider} />}
    </Fragment>
  );
}

export default VehicleInformation;
